export default __webpack_public_path__ + "static/media/avatar_panda4.2befefab.mp3";